let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');
let accessibility = require('../utilities/accessibility');
// Import Greensock and it's plugins.
let CSSPlugin = require('../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');
let EasePack = require('../../node_modules/gsap/src/uncompressed/easing/EasePack');
let TweenLite = require('../../node_modules/gsap/src/uncompressed/TweenLite');

class GlossaryToolTips {

  constructor() {
    this.$seeRelated = $('.js-glossary-see-related');
    this.$itemWrappers = $('.glossary-item__wrapper');
    this.$relatedWrappers = $('.glossary-item-related__wrapper');
    this.openClass = 'related-open';

    // Resize event to resize related area.
    $(window).resize(() => this.resizeRelated()).trigger('resize');

    // Bind click events to 'see related'.
    this.$seeRelated.off('click.glossaryRelated').on('click.glossaryRelated', (e) => this.handleRelatedClick(e));

    // Make sure all hidden items are not tabbable.
    this.$relatedWrappers.each((index) => {
      let $item = this.$relatedWrappers.eq(index);

      accessibility.toggleTabbing($item, this.openClass, false);
    })
  }

  handleRelatedClick(e) {
    let $target = $(e.target);
    let $wrapper = $target.parents('.glossary-item__wrapper');
    let $relatedWrapper = $wrapper.find('.glossary-item-related__wrapper');

    if (!$wrapper.hasClass('related-open')) {
      this.closeAll();
      this.openRelated($relatedWrapper);
    }
    else if($wrapper.hasClass('related-open')) {
      this.closeRelated($relatedWrapper);
    }
  }

  closeAll() {
    this.$itemWrappers.each((index, elem) => {

      let $relatedWrapper = $(elem).find('.glossary-item-related__wrapper');
      if ($(elem).hasClass('related-open')) {
        this.closeRelated($relatedWrapper);
      }
    });
  }

  /*
    openRelated() closes a related area.
    $item - a jquery obj representing the item to open.
  */
  openRelated($item) {
    let $wrapper = $item.parents('.glossary-item__wrapper');
    let $relatedWrapper = $wrapper.find('.glossary-item-related__wrapper');
    let $relatedContent = $relatedWrapper.find('.glossary-item-related');
    let $closeBtn = $item.find('.js-glossary-related-close');

    let newHeight = this.getHeight($relatedContent);

    window.TweenLite.to($item, 0.45, {
      height: newHeight,
      opacity: 1,
      ease: Power2.easeIn,
      onComplete: () => {
        $relatedWrapper.attr('aria-hidden', 'false');
        $wrapper.addClass(this.openClass);
        accessibility.toggleTabbing($wrapper, this.openClass, $closeBtn);

        // Bind click to close button.
        $closeBtn.off('click.closeGlossary').on('click.closeGlossary', () => this.closeRelated($item));
      }
    });
  }

  /*
    openRelated() closes a related area.
    $item - a jquery obj representing the item to open.
  */
  closeRelated($item) {
    let $wrapper = $item.parents('.glossary-item__wrapper');
    let $relatedWrapper = $wrapper.find('.glossary-item-related__wrapper');
    let $relatedBtn = $wrapper.find('.js-glossary-see-related');

    accessibility.toggleTabbing($relatedWrapper, this.openClass, false);

    window.TweenLite.to($item, 0.45, {
      height: 0,
      opacity: 0,
      ease: Power2.easeOut,
      onComplete: () => {
        $relatedWrapper.attr('aria-hidden', 'true');
        $wrapper.removeClass(this.openClass);
        accessibility.toggleTabbing($relatedWrapper, this.openClass, $relatedBtn);
      }
    });
  }

  getHeight($activeItem) {
    let height;
    let vertMargin = parseInt($activeItem.css('margin-top')) + parseInt($activeItem.css('margin-bottom'));
    height = parseInt($activeItem.outerHeight()) + vertMargin;

    return height;
  }

  resizeRelated() {
    let $activeWrapper = $('.glossary-item__wrapper.related-open');
    let $activeRelatedWrapper = $activeWrapper.find('.glossary-item-related__wrapper');
    let $activeRelated = $activeWrapper.find('.glossary-item-related');
    let activeHeight = this.getHeight($activeRelated);

    $activeRelatedWrapper.css('height', activeHeight);
  }

}

module.exports = {
  attach: function(context, settings) {
    let glossaryToolTips = new GlossaryToolTips();
  }
}
